// Lets code outside the Router tree (e.g. AuthContext, which wraps Router rather than
// sitting inside it) trigger navigation. Populated by NavigationSetter, which is
// mounted inside <Router> in App.jsx.
const navigationRef = { current: null };

export default navigationRef;
